import { AdjustTermKey, AdjustTerms, PairedSalesAnalysisFeature } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import {
  CustomTPColumn,
  SystemAccessorTPColumnKey,
  TPColumnKey,
} from '../../../../components/ToolkitPropertyTable/types.ts';
import { proximityFormat } from '../../../../utils/proximityFormat.ts';
import { proximityMiles } from '../../../../utils/proximityMiles.ts';
import { isPairedSalesCustomAnalysisFeature } from '../../utils/isPairedSalesCustomAnalysisFeature.ts';
import { getColumnDefForTerm } from './getColumnDefForTerm.tsx';
import { PairedSalesTableRow } from './types.ts';

const leftColumns: TPColumnKey[] = ['address'];

const rightColumns: (TPColumnKey | SystemAccessorTPColumnKey | AdjustTermKey)[] = [
  'site',
  'grossLivingArea',
  'aboveGradeBedroomCount',
  'baths',
  'yearBuilt',
  'garageParkingSpacesCount',
  'dateOfSale',
  'salePrice',
  'listingStatus',
  'listingID',
];

const getRightColumns = (
  selectedTerm: PairedSalesAnalysisFeature,
): CustomTPColumn<PairedSalesTableRow>[] => {
  const columns: CustomTPColumn<PairedSalesTableRow>[] = [];
  for (const key of rightColumns) {
    const isTerm = Object.keys(AdjustTerms).includes(key);
    if (isTerm && key === selectedTerm) continue;
    if (isTerm) {
      columns.push(...getColumnDefForTerm(key as AdjustTermKey));
    } else {
      columns.push(key as TPColumnKey);
    }
  }

  return columns;
};

/** Creates a column for the selected term if it's not a default column. Always shows the selected term in the second column. */
export const getTableColumns = (
  term: PairedSalesAnalysisFeature,
): CustomTPColumn<PairedSalesTableRow>[] => [
  ...leftColumns,
  ...(isPairedSalesCustomAnalysisFeature(term) ? [] : getColumnDefForTerm(term)),
  {
    id: 'custom$proximity',
    title: 'Proximity',
    selector: (x: PairedSalesTableRow) => proximityMiles({ ...x.p1 }, { ...x.p2 }),
    toCell: (x: number | undefined) => (
      <Typography variant="tableH2" truncate>
        {proximityFormat(x)}
      </Typography>
    ),
    sortBy: (a: number | undefined, b: number | undefined) =>
      a === b ? 0 : (a ?? -Infinity) - (b ?? -Infinity),
  },
  ...getRightColumns(term),
];
